module.exports = __webpack_public_path__ + "img/41_48.e62e3395.png";